export default {
    productItem: {
        padding: '21px',
        border: '3px solid',
        borderColor: 'white',
        margin: '0 -24px'
    }
}
